import { Phone, Mail } from "lucide-react";
import { CONTACT } from "./NSLogo";

export default function ContactBar({ dark = false }) {
  const bg = dark ? "bg-[#111111] text-[#F5F3EF] border-[#2A2A2A]" : "bg-[#111111] text-[#F5F3EF] border-b border-[#2A2A2A]";
  return (
    <div
      data-testid="contact-bar"
      className={`${bg} w-full`}
    >
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-2.5 flex flex-wrap items-center justify-end gap-x-6 gap-y-1">
        <div className="flex flex-wrap items-center gap-x-6 gap-y-1">
          <a
            href={CONTACT.phoneHref}
            data-testid="contact-bar-phone"
            className="group inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-[#F5F3EF] hover:text-[#C17A43] transition-colors"
          >
            <Phone size={12} strokeWidth={2} />
            <span>{CONTACT.phone}</span>
          </a>
          <span className="text-[#F5F3EF]/30 hidden sm:inline">·</span>
          <a
            href={CONTACT.emailHref}
            data-testid="contact-bar-email"
            className="group inline-flex items-center gap-2 font-mono text-[11px] normal-case tracking-[0.1em] text-[#F5F3EF] hover:text-[#C17A43] transition-colors"
          >
            <Mail size={12} strokeWidth={2} />
            <span>{CONTACT.email}</span>
          </a>
        </div>
      </div>
    </div>
  );
}
